<template>
  <component
    :is="as"
    :class="computedClass"
    :style="{ objectFit }"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot v-if="$slots.default"></slot>
  </component>
</template>

<script>
const ASPECT_RATIO_ENUM = {
  SQUARE: 'square',
  LANDSCAPE: 'landscape',
  WIDE: 'wide',
  ULTRAWIDE: 'ultrawide'
}

const OBJECT_FIT_ENUM = {
  NONE: 'none',
  CONTAINER: 'container',
  COVER: 'cover',
  FILL: 'fill',
  SCALE_DOWN: 'scale-down'
}

export default {
  name: 'JadeAspectRatio',

  props: {
    as: {
      type: String,
      default: 'img'
    },
    aspectRatio: {
      type: String,
      default: ASPECT_RATIO_ENUM.SQUARE,
      validation: v => Object.values(ASPECT_RATIO_ENUM).includes(v)
    },
    objectFit: {
      type: String,
      validation: v => Object.values(OBJECT_FIT_ENUM).includes(v)
    }
  },

  computed: {
    computedClass () {
      return {
        'jade-aspect-ratio': true,
        [`is-${this.aspectRatio}`]: this.aspectRatio
      }
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/aspect-ratio.css';
</style>
